import { Box, Button, IconArrow } from 'braid-design-system';
import React from 'react';

import { getConfigValues } from 'src/config';
import Routes from 'src/config/routes';
import { useAuth } from 'src/hooks/auth';
import { fireRegistrationEvent } from 'src/utils/analytics';
import { setGlobalCookie } from 'src/utils/cookies';

export const GetAccessButton = () => {
  const isLogin = useAuth();

  const onRegisterClick = async () => {
    // If user is logged in or has logged in before
    const isLoggedIn = isLogin.getAuthToken();
    if (!isLoggedIn) {
      await fireRegistrationEvent('Sem', 'Start');
      const anHourLater = new Date();
      anHourLater.setHours(anHourLater.getHours() + 1);
      setGlobalCookie('OnboardPageSource', 'SEMLandingPage', '/');
    }

    window.location.assign(
      `${getConfigValues().HEADER_SERVER_BASE}${Routes.SIGN_IN_URL}?returnUrl=${
        Routes.DASHBOARD
      }?selectedTab=tools`,
    );
  };

  return (
    <Box maxWidth="xsmall" marginTop="gutter">
      <Button
        id="learn-more-button"
        tone="brandAccent"
        variant="soft"
        onClick={onRegisterClick}
      >
        Get access&nbsp;&nbsp;
        <IconArrow direction="right" />
      </Button>
    </Box>
  );
};
